import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/views/AuthCallbackView.vue'),
    },
    {
      path: '/auth/mcp/start',
      name: 'mcp-auth-start',
      component: () => import('@/views/McpOAuthStartView.vue'),
    },
    {
      path: '/auth/mcp/callback',
      name: 'mcp-auth-callback',
      component: () => import('@/views/McpOAuthCallbackView.vue'),
    },
    {
      path: '/embed/:botName',
      component: AppLayout,
      meta: { authSurface: 'embedded', authGateScope: 'view', chatSurface: 'helper_embed', launchContext: 'cas' },
      children: [
        {
          path: '',
          name: 'embed-chat',
          component: () => import('@/views/EmbedChatView.vue'),
          meta: { authSurface: 'embedded' },
        },
      ],
    },
    {
      path: '/assignments/:botName',
      name: 'assignment-chat',
      component: () => import('@/views/AssignmentChatView.vue'),
      meta: { authSurface: 'embedded', chatSurface: 'canvas_assignment', launchContext: 'lti_assignment' },
    },
    {
      path: '/canvas',
      component: AppLayout,
      meta: { authSurface: 'embedded', chatSurface: 'canvas_workspace', launchContext: 'lti_study' },
      children: [
        {
          path: '',
          name: 'canvas-landing',
          component: () => import('@/views/CanvasLandingView.vue'),
          meta: { chatSurface: 'canvas_workspace', launchContext: 'lti_study' },
        },
        {
          path: 'bots/:botName',
          name: 'canvas-bot-name',
          component: () => import('@/views/CanvasChatView.vue'),
          meta: { chatSurface: 'canvas_bot', launchContext: 'lti_study' },
        },
        {
          path: 'bots/:botId/:botSlug?/sessions/:sessionId?',
          name: 'canvas-bot-session',
          component: () => import('@/views/CanvasChatView.vue'),
          meta: { chatSurface: 'canvas_bot', launchContext: 'lti_study' },
        },
      ],
    },
    {
      path: '/',
      component: AppLayout,
      meta: { authSurface: 'full', chatSurface: 'desktop_workspace', launchContext: 'cas' },
      children: [
        {
          path: '',
          name: 'landing',
          component: () => import('@/views/LandingView.vue'),
        },
        {
          path: 'bots/:botName',
          name: 'bot-name',
          component: () => import('@/views/ChatView.vue'),
        },
        {
          path: 'bots/:botId/:botSlug?/sessions/:sessionId?',
          name: 'bot-session',
          component: () => import('@/views/ChatView.vue'),
        },
      ],
    },
  ],
})

export default router
